// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './form-field-errors.scss';

function FormFieldErrors({errors, onlyShowFirstError}) {
    return (
        <div className="form-field-errors">
            {onlyShowFirstError && errors.length ? (
                <div className="errors--error">{errors[0]}</div>
            ) : (
                errors.map((error, key) => (
                    <div className="errors--error" key={key}>
                        {error}
                    </div>
                ))
            )}
        </div>
    );
}

FormFieldErrors.propTypes = {
    errors: PropTypes.array.isRequired,
    onlyShowFirstError: PropTypes.bool,
};

export default FormFieldErrors;
